import { render, staticRenderFns } from "./NewFeatureIcon.vue?vue&type=template&id=c7a0d300&"
import script from "./NewFeatureIcon.vue?vue&type=script&lang=js&"
export * from "./NewFeatureIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports